define('modules/header-profile',[
  'jquery',

  'modules/options-menu',

  'connections/profile-connection',

  'utils/form-validator',
  'utils/local-storage',
  'utils/debounce',

  'rivets',
  'settings',
  'utils/rivets-formatters'
], function ($, OptionsMenu, ProfileConnection, FormValidator, localStorage, debounce, Rivets, settings) {
  /**
   * @class Login
   */
  var HeaderProfile = (function () {
    function HeaderProfile(btns) {
      this.btns = btns;
      this.el = $('#profile');

      this.btns.on('click', this.toggleProfile.bind(this));
      this.el.on('click', '.aside-slidein__close-button', this.toggleProfile.bind(this));

      if (!this.isLoggedin()) {
        this.initLoginForm();
      } else {
        if (localStorage.get('loginBubble', true) !== 'hide') {
          $('#header-profile-tooltip')
            .append($('.header-profile__name').text())
            .delay(1500)
            .fadeIn('fast')
            .delay(4000)
            .fadeOut('fast');
          localStorage.set('loginBubble', 'hide', true);
        }

        // Reset storage for new login.
        $('#logout-action').on('click', function () {
          localStorage.delete('loginBubble', true);
          localStorage.delete('userSellerContact_' + settings.user.userName, true);
          return true;
        });

        this.btns.one('click', this.initInteractions.bind(this));
      }
    }

    HeaderProfile.prototype.initInteractions = function () {
      this.el.on('click', '.aside-slidein__options, .options-menu', OptionsMenu.toggle);
      OptionsMenu.addBodyCloseListener('.aside-slidein__options');
      OptionsMenu.addBodyCloseListener('.options-menu');

      this.el.on('click', '#profile-preferred-colors li', this.selectColor);
      $('[name="price-radio"]').on('change', this.changePriceSetting);

      if (settings.user && settings.user.isSeller) {
        if (settings.user.hasRole) {
          $('[data-log-out-customer]').on('click', function () {
            HeaderProfile.prototype.removeActingRole();
          });
        } else this.showCustomerSelector();
      } else {
        this.showCustomerService();
      }

      this.bindSections();
    };

    HeaderProfile.prototype.bindSections = function () {
      var storedClosedSections = localStorage.get('closedUserSections');

      function store() {
        var closedSections = [];
        $('.header-profile__section.minimized').each(function (i, el) {
          closedSections.push(el.id);
        });
        localStorage.set('closedUserSections', closedSections);
      }

      if (storedClosedSections && $.isArray(storedClosedSections)) {
        $.each(storedClosedSections, function (i, sectionId) {
          $('#' + sectionId).addClass('minimized');
        });
      }

      $('.header-profile__section h3, .toggle-section-button').on('click', function () {
        $(this).closest('.header-profile__section').toggleClass('minimized');
        store();
      });
    };

    HeaderProfile.prototype.showCustomerService = function () {
      var $customerService = $('.header-profile__customer-service');
      if (!$customerService.length) return;

      var storagekey = 'userSellerContact_' + settings.user.userName;
      var contactName = localStorage.get(storagekey, true);

      if (contactName) {
        $customerService.find('.customer-contact__name').text(contactName);
      } else {
        ProfileConnection.getUserContact().then(function (res) {
          if (res.contact) {
            $customerService.find('.customer-contact__name').text(res.contact);
            localStorage.set(storagekey, res.contact, true);
          }
        });
      }

      $customerService.show();
    };

    HeaderProfile.prototype.selectColor = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var color = $(this).data('color');
      var colorLower = color.toLowerCase();
      var $currentLabel = $('.header-profile__selected-color');
      var prevColor = $currentLabel.data('color').toLowerCase();

      if (prevColor === colorLower) return $('#profile-preferred-colors').removeClass('open');

      ProfileConnection.setPreferredColor({ color: color })
        .then(function (res) {
          $currentLabel.removeClass(prevColor).addClass(colorLower).data('color', color);
          HeaderProfile.prototype.settingsChanged();
        })
        .always(function () {
          $('#profile-preferred-colors').removeClass('open');
        });
    };

    HeaderProfile.prototype.changePriceSetting = function () {
      ProfileConnection.showPrice({ price: $(this).val() }).then(function () {
        HeaderProfile.prototype.settingsChanged();
      });
    };

    HeaderProfile.prototype.settingsChanged = function () {
      $('.header-profile__settings-changed').addClass('open');
    };

    HeaderProfile.prototype.toggleProfile = function () {
      var _this = this;
      var overlay = $('.profile__overlay');

      this.el.toggleClass('open');

      if (this.el.hasClass('open')) {
        overlay.addClass('active');
      } else {
        overlay.removeClass('active');
      }

      overlay.off('click').on('click', function () {
        $(this).removeClass('active');
        _this.el.removeClass('open');
      });
    };

    HeaderProfile.prototype.closeHeaderProfile = function () {
      this.el.removeClass('open');
      $('.profile__overlay').off('click').removeClass('active');
    };

    HeaderProfile.prototype.isLoggedin = function () {
      if (this._isLoggedin === undefined) {
        this._isLoggedin = !this.el.find('.login').length;
      }

      return this._isLoggedin;
    };

    HeaderProfile.prototype.getLogin = function () {
      if (!this.isLoggedin()) {
        return false;
      }

      if (this._login === undefined) {
        this._login = settings.user.username;
      }

      return this._login;
    };

    HeaderProfile.prototype.initLoginForm = function () {
      this.form = this.el.find('.login').find('form');
      this.addLoginFormValidation();

      this.formRivetsData = this.formRivetsData || {};
      this.formRivetsData.serverError = this.getInitialServerErrorCode();
      Rivets.bind(this.form, this.formRivetsData);

      if (this.formRivetsData.serverError !== false) {
        this.toggleProfile();
      }
    };

    HeaderProfile.prototype.addLoginFormValidation = function () {
      var _this = this;

      this.validator = new FormValidator(this.form);
      this.validator.removeInputErrorMsgOn('keypress');

      this.form.on('submit', function (e) {
        var submitButton = _this.form.find('button[type="submit"]');

        if (!_this.validator.validateForm()) {
          e.preventDefault();
        } else if (!_this._skipUserInfoRequest) {
          submitButton.prop('disabled', true);
          e.preventDefault();
          _this.getUserInfo();
        }
      });
    };

    HeaderProfile.prototype.getInitialServerErrorCode = function () {
      var serverError = false,
        match = window.location.href.match(/loginerror=(\d+)/i);

      if (match) {
        serverError = match[1];
      }

      return serverError;
    };

    HeaderProfile.prototype.loginUser = function (customerCode) {
      this._skipUserInfoRequest = true;

      if (customerCode) {
        this.form.find('[name="CustomerCode"]').val(customerCode);

        var i, customerName;
        for (i = 0; i < this.sellerCustomersList.length; i++) {
          if (String(this.sellerCustomersList[i].customerCode) === String(customerCode)) {
            customerName = this.sellerCustomersList[i].Name;
            break;
          }
        }

        if (customerName) {
          this.form.find('[name="CustomerName"]').val(customerName);
        }
      }

      this.form.submit();
    };

    HeaderProfile.prototype.getUserInfo = function () {
      var _this = this;

      if (this.userInfoRequest && 'abort' in this.userInfoRequest) {
        this.userInfoRequest.abort();
      }

      _this.loginUser();
    };

    HeaderProfile.prototype.showCustomerSelector = function (userInfo) {
      var _this = this;
      var input = this.el.find('#retailer-form').find('input');
      var loader = this.el.find('.header-customer-selector__loader');
      var button = loader.parent();
      var customerSelector = this.el.find('.header-customer-selector');
      var customerSelectorMenu = customerSelector.find('.header-customer-selector__menu');

      this.sellerCustomersList = [];
      Rivets.bind(customerSelector, { customersList: this.sellerCustomersList });

      var inputHandler = function (e) {
        // always serach on search button click, but filter less than 3 chars on input events
        if (input.val().length < 3 && e.type === 'input') {
          _this.sellerCustomersList.splice(0);
          return;
        }

        loader.removeClass('hidden');
        button.removeClass('icon-search');
        ProfileConnection.searchCustomers(input.val())
          .then(function (customersList) {
            // empty previous results and push new list. Replacing is not liked by rivets.
            _this.sellerCustomersList.splice(0);
            for (var index = 0; index < customersList.length; index++) {
              _this.sellerCustomersList.push(customersList[index]);
            }
          })
          .always(function () {
            loader.addClass('hidden');
            button.addClass('icon-search');
          });
      };

      input.on('input', debounce(inputHandler, 200));
      button.on('click', inputHandler);

      customerSelectorMenu.on('click', 'a', function (e) {
        e.preventDefault();
        ProfileConnection.setActingRole($(this).data('customer-email')).then(function () {
          // Cookie set from BE, reloading.
          location.reload();
        });
      });

      customerSelector.show();
    };

    HeaderProfile.prototype.removeActingRole = function () {
      ProfileConnection.removeActingRole().then(function () {
        // Cookie set from BE, reloading.
        location.reload();
      });
    };

    HeaderProfile.prototype.getEmail = function () {
      if (this.form && this.form.length && this.form.find('[name="Email"]').length)
        return this.form.find('[name="Email"]').val();

      return false;
    };

    HeaderProfile.prototype.getPassword = function () {
      if (this.form && this.form.length && this.form.find('[name="Password"]').length)
        return this.form.find('[name="Password"]').val();

      return false;
    };

    return HeaderProfile;
  })();

  return new HeaderProfile($('.header-profile-btn'));
});

